// API Configuration

// Base URL for API requests
export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:8000/api';

// Auth endpoints
export const AUTH_ENDPOINTS = {
  LOGIN: '/login',
  REGISTER: '/users',
  LOGOUT: '/logout',
  REFRESH: '/refresh',
  CURRENT_USER: '/me',
};

// Task endpoints
export const TASK_ENDPOINTS = {
  TASKS: '/tasks',
  TASKS_BY_DAY: (date) => `/tasks/day/${date}`,
  CATEGORIES: '/tasks/categories',
  DASHBOARD_SUMMARY: '/tasks/analytics/dashboard',
  CATEGORY_TIME: '/tasks/analytics/category-time',
  WEEKLY_COMPLETION: '/tasks/analytics/weekly-completion',
};

// Note endpoints
export const NOTE_ENDPOINTS = {
  NOTES: '/notes/all',
  SHARED_NOTE: (id) => `/notes/${id}/share`,
};

// File endpoints
export const FILE_ENDPOINTS = {
  UPLOAD: '/files/upload',
  FILES: '/files',
  FILE_BY_ID: (id) => `/files/${id}`,
  DELETE_FILE: (id) => `/files/${id}`,
};

export default {
  API_BASE_URL,
  AUTH_ENDPOINTS,
  TASK_ENDPOINTS,
  NOTE_ENDPOINTS,
  FILE_ENDPOINTS,
}; 